import { all } from 'redux-saga/effects'

//public
import loginSaga from './auth/login/saga';
import forgetSaga from './auth/forgetpwd/saga';
import LayoutSaga from './layout/saga';
import UserSaga from './user/saga';
import RoleSaga from './role/saga';
import ProfileSaga from './profile/saga';
import GeneralSaga from './general/saga';
import DashboardSaga from './dashboard/saga';
import LocationSaga from './location/saga';
import PermissionSaga from './permission/saga';
import ReuseableSettingSaga from './setting/saga';
import NotificationSaga from './notification/saga';
import CreditSaga from './credit/saga';
import DoctorSaga from './doctors/saga';
import CustomerSaga from './customer/saga';
import OrderSaga from './order/saga';
import ShippingZoneSaga from './shippingZone/saga';
import AdminSaga from './admin/saga';
import ReportSaga from './report/saga';

export default function* rootSaga() {
        yield all([
                //public
                loginSaga(),
                UserSaga(),
                GeneralSaga(),
                RoleSaga(),
                PermissionSaga(),
                ProfileSaga(),
                forgetSaga(),
                LayoutSaga(),
                DashboardSaga(),
                CreditSaga(),
                DoctorSaga(),
                CustomerSaga(),
                OrderSaga(),
                ShippingZoneSaga(),
                AdminSaga(),
                ReportSaga(),
                NotificationSaga(),
                //Setting
                LocationSaga(),
                ReuseableSettingSaga(),
        ])
}